import { classify } from 'sidecar-utilities'

import { Sentiment } from '@sidecar-components/types'

// the sentiment changes a few different things across the component
// so we'll first set that up and get it out of the way before assigning
// to the styles objects.
// Define the color mappings for each sentiment
const colorMappings = {
  [Sentiment.ACCENT]: {
    background: 'color-background-accent',
    border: 'color-borderAccent-default',
    icon: 'color-iconOnAccent-default',
    dismissIcon:
      'color-iconOnAccent-default hover:color-iconOnAccent-hover active:color-iconOnAccent-active',
    title:
      '[&_h4]:color-textOnAccent-bold-default [&_strong.inherit]:color-textOnAccent-bold-default',
    message: 'color-textOnAccent-default',
    disclaimer: 'color-textOnAccent-weak-default',
    focus: 'focus:color-outlineAccent-default',
  },
  [Sentiment.NOTIFY]: {
    background: 'color-background-notify',
    border: 'color-borderNotify-default',
    icon: 'color-iconOnNotify-default',
    dismissIcon:
      'color-iconOnNotify-default hover:color-iconOnNotify-hover active:color-iconOnNotify-active',
    title:
      '[&_h4]:color-textOnNotify-bold-default [&_strong.inherit]:color-textOnNotify-bold-default',
    message: 'color-textOnNotify-default',
    disclaimer: 'color-textOnNotify-weak-default',
    focus: 'focus:color-outlineNotify-default',
  },
  [Sentiment.RISK]: {
    background: 'color-background-risk',
    border: 'color-borderRisk-default',
    icon: 'color-iconOnRisk-default',
    dismissIcon:
      'color-iconOnRisk-default hover:color-iconOnRisk-hover active:color-iconOnRisk-active',
    title:
      '[&_h4]:color-textOnRisk-bold-default [&_strong.inherit]:color-textOnRisk-bold-default',
    message: 'color-textOnRisk-default',
    disclaimer: 'color-textOnRisk-weak-default',
    focus: 'focus:color-outlineHighRisk-default',
  },
}
const getColors = (sentiment, styleType) =>
  colorMappings[sentiment]?.[styleType] || ''

export const baseStyles = ({
  sentiment,
  dismissed,
  icon,
}: {
  dismissed?: boolean
  icon?: string
  sentiment: Sentiment
}) =>
  classify({
    background: getColors(sentiment, 'background'),
    border: `border ${getColors(sentiment, 'border')}`,
    icon: icon === 'checkmark' ? 'checkmark' : 'exclamation',
    layout:
      'block mb-4 rounded-lg items-start sm:p-4 p-2 flex flex-row gap-2 last:mb-0',
    width: 'w-full',
    dismissed: dismissed ? 'hidden' : null,
    colors: getColors(sentiment, 'title'),
  })

export const contentStyles = 'block align-middle w-full'

export const iconStyles = sentiment =>
  classify({
    colors: getColors(sentiment, 'icon'),
    // y margin makes the icon vertically centered with the first line of text.
    // Using margin because padding shrinks the icon.
    layout: 'my-1',
  })

export const titleStyles = sentiment =>
  classify({
    font: 'font-sans-bold',
    title: getColors(sentiment, 'title'),
  })

export const messageStyles = sentiment =>
  classify({
    font: 'sh-body',
    colors: getColors(sentiment, 'message'),
  })

export const disclaimerStyles = sentiment =>
  classify({
    font: 'sh-body-xs',
    colors: getColors(sentiment, 'disclaimer'),
  })

// y padding makes the icon vertically centered with the first line of text.
// Using padding to increase the click area.
export const dismissIconStyles = 'my-1'
